import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
  Button,
  CloseButton,
  Col,
  Container,
  Dropdown,
  Modal,
  Row,
  Tab,
  Tabs,
} from "react-bootstrap";
import styled from "styled-components";

import ContentWrapper from "../../components/content-wrapper";

export const StyledFontAwesomeIcon = styled(FontAwesomeIcon)`
  text-align: right;
  float: right;
  color: #cccccc;
  margin-top: 4px;
`;

export const StyledDropdown = styled(Dropdown)`
  width: ${props => props.width};
`;

export const StyledModalBody = styled(Modal.Body)`
  maxheight: "80vh";
  height: "80vh";
  overflowy: "auto";
`;

export const StyledDropdownToggle = styled(Dropdown.Toggle)`
  width: 100%;
  text-align: left;
  background-color: white !important;
  color: #495057 !important;
  border-color: #ddd !important;
  &:after {
    display: none !important;
  }
`;

export const StyledDropdownMenu = styled(Dropdown.Menu)`
  width: 100%;
  max-height: 300px;
  overflow: hidden;
  overflow-y: scroll;
`;

export const StyledDropdownItem = styled(Dropdown.Item)`
  font-size: 12px;
  color: #495057;
`;

export const MainContainer = styled(ContentWrapper)<{ odd: boolean; resultsMsg: string }>`
display: flex;
flex-flow: column nowrap;
height: 106%;

.dx-g-bs4-paging-panel {
  display: flex;
  flex-flow: row-reverse;
  justify-content: space-between;
}

.dx-g-bs4-paging-panel > nav {
  margin-right: auto;
  float: none !important;
}

.dx-g-bs4-paging-panel > div {
  display: flex !important;
  align-items: center;
}

.dx-g-bs4-paging-panel > div:first-child {
  padding-left: 20px;
  position: relative;
}

.dx-g-bs4-paging-panel > div:first-child:before {
  position: absolute;
  left: -150px;
  font-weight: 600;
  content: "${props => props.resultsMsg}";

}
.dx-g-bs4-table-head {
  font-size: 11px;
  color: ${({ theme }) => theme.regularTextColor};
  font-family: ${({ theme }) => theme.regularTextTypeface};
}

.alert {
  margin-bottom: 0;
}

.table-responsive {
  background-color: rgb(245, 247, 250);
  .table {
    td {
      font-size: 11px;
      word-break: break-word;
      padding: 0 5px;
      vertical-align: middle;
    }
    margin-bottom: 0;
    tr td:first-child,
    th:first-child {
      padding-left: 20px;
    }
    th > div > div {
      text-transform: uppercase;
    }
    th {
      padding: 5px;
      max-width: 100px;
      word-break: break-word;
      background-color: rgb(250, 251, 252);
    }
  }
}

.even {
  background-color: rgb(250,251,252) !important;
}

.odd{
  background-color: rgb(245, 247, 250) !important;
}

.dx-g-bs4-fixed-cell {
  border-left: 1px solid rgb(222,226,230);
  z-index:0;
}    

.dx-g-bs4-header-cell.dx-g-bs4-fixed-cell {
  background-color: rgb(250,251,252) !important
}   

}
`;

export const StyledContainerInputIcon = styled.div`
  display: flex;
  align-items: center;
  border: 1px solid #ddd;
  border-radius: 0.25rem;
  &:focus {
    outline: 0px !important;
  }
`;

export const StyledInputIcon = styled.input`
  border: 0px;
  width: 90%;
  height: 33px;
  padding: 8px;
  &:focus {
    outline: 0px !important;
  }
`;
export const StyledSpanTitleTab = styled.span`
  padding-right: 10px;
  font-size: 14px;
  font-weight: 600;
  color: #656565;
  line-height: 1;
`;

export const StyledCloseButton = styled(CloseButton)`
  color: "#B3B3B3";
  font-weight: 600;
  font-size: 20px;
  &:focus {
    outline: 0px !important;
  }
`;

export const StyledTabs = styled(Tabs)`
  padding: 0px 15px 0px 15px;

  .nav-link {
    border-color: #ced4da;
  }

  .nav-link:last-child {
    border-color: transparent;
  }
`;

export const StyledTab = styled(Tab)``;

export const StyledContainerTab = styled.div`
  padding: 20px;
`;

export const StyledGrid = styled(Container)`
  max-width: 100% !important;
  padding: ${props => (props.padding ? props.padding : "auto")};
  background-color: white;
`;

export const StyledRow = styled(Row)`
  padding-top: ${props => (props.paddingTop ? props.paddingTop : "auto")};
`;

export const StyledCol = styled(Col)`
  padding-left: 8px !important;
  padding-right: 8px !important;
  padding: ${props => (props.padding ? props.padding : "auto")};
  display: flex;
  align-items: center;
  justify-content: ${props => (props.justifyContent ? props.justifyContent : "left")};
`;

export const StyledButton = styled(Button)`
  width: 100%;
  cursor: ${props => (props.disabled ? "not-allowed" : "pointer")};
`;

export const StyledModalButton = styled(Button)`
  width: 76px;
`;

export const StyledModalCloseButton = styled(Button)`
  width: ${props => (props.width ? props.width : "76px")};
  background-color: #b3b3b3 !important;
  margin-left: ${props => (props.marginLeft ? props.marginLeft : "auto")};
`;

export const StyledButtonPromoCode = styled(Button)`
  border-radius: 0px 3px 3px 0px;
`;

export const StyledBoxAccommodation = styled.div`
  display: block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  font-size: 13px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const StyledSpanPax = styled.span`
  padding-top: 28px;
  color: #656565;
  font-size: 21px;
  line-height: 24px;
  font-weight: 600;
`;

export const StyledSpanTotal = styled.span`
  font-style: normal;
  font-weight: 600;
  font-size: 21px;
  line-height: 24px;
  letter-spacing: -0.02em;
  color: #656565;
`;

export const StyledSpanDeposit = styled.span`
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: -0.02em;
  color: #656565;
`;

export const StyledButtonIconBorder = styled(Button)`
  border: 1px solid #ced4da !important;
  border-radius: 0.25rem !important;
`;

export const StyledPlusTab = styled.span`
  font-style: normal;
  font-weight: 600;
  font-size: 18px;

  letter-spacing: -0.02em;
  color: #656565;
`;

export const StyledModalTextInvalidCode = styled.div`
  padding: 20px 12px 12px 12px;
  text-align: center;
  font-size: "16px";
  font-weight: 600;
  color: #ff6136;
`;

export const StyledValueExtra = styled.span`
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 21px;
  letter-spacing: -0.02em;
  color: #656565;
  font-family: Arial;
`;

export const StyledTypeExtra = styled.span`
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 15px;
  letter-spacing: -0.02em;
  color: #656565;
  font-family: Arial;
  padding-bottom: 12px;
`;

export const StyledContainerButtonsExtra = styled.div`
  margin: 20px auto;
`;

export const StyledTitleExtra = styled.span`
  font-weight: 600;
  color: #656565;
  font-size: 18px;
  line-height: 21px;
  font-family: Arial;
  padding-bottom: 10px;
`;

export const StyledDescriptionExtra = styled.span`
  font-weight: 400;
  color: #656565;
  font-size: 14px;
  font-family: Arial;
`;

export const StyledTextEnjoy = styled.span`
  font-weight: 600;
  color: #656565;
  font-size: 14px;
  font-family: Arial;
`;

export const StyledModalEmailTitle = styled.span`
  color: #656565;
  font-size: 21px;
  font-family: "Arial";
  font-style: normal;
  font-weight: 600;
  line-height: 15px;
  margin-bottom: 40px;
`;
export const StyledModalEmailSubtitle = styled.span`
  color: #656565;
  font-size: 14px;
  font-family: "Arial";
  font-style: normal;
  font-weight: 400;
  line-height: 15px;
  margin-top: 20px;
  margin-bottom: 20px;
`;
export const StyledWrapperInput = styled.div`
  display: flex;
  align-items: center;
  margin-right: 12px;
  margin-top: 20px;
  margin-bottom: 20px;
  gap: 10px;
`;
export const StyledModalEmailLabelInput = styled.span`
  font-weight: 600;
  font-size: 14px;
  width: 80px;
`;
